/* Dispatch line and delivery estimate shared by every surface: the product page (assets/tc-pdp.js and the [data-tc-eta] line under
   Add to cart), the landing pages' buy box and sticky bar, the cart drawer (assets/tc-cart.js) and the header bar.
   Rule (set by Chad 2026-10-22): orders ship in 1 to 3 business days and arrive 3 to 7 business days after the order. There is no
   order deadline any more: orders ship from Amazon Multi-Channel Fulfillment, not our own warehouse, so the time of day doesn't
   change anything. Business day = Monday to Friday, not a US federal holiday (observed dates). The calendar covers 2026 and 2027 only:
   outside it, text() still returns the generic line and eta() returns null rather than a day it can't prove. Add the next year's
   dates before 2028.
   Calibration: 22 web MCF orders Oct 10-21 2026. Ship 0-3 business days after the order (shipped on the order day only 5 of 22, p85 2);
   delivered 0-5 business days after the order (16 of 16 delivered); Amazon's own estimated delivery dates on the open orders reached
   7 business days. Chad set the public promise at 3-7 business days on 2026-10-22; see storefront-upgrade-2026-09-29/delivery-promise-2026-10-22.
   Expedited (2026-11-04, mcf-expedited-upgrade-2026-11-04): the checkout rate "Expedited delivery" ($9.95 under $100, free at $100+) maps to
   MCF Expedited, which Amazon delivers in 2 business days when the order is in before its afternoon cutoff. eta().fast = the 2nd business day
   after the order date before 2 PM ET, the 3rd after it (the same holiday calendar). Modes fastday / fastrow paint it in the cart drawer
   and under Add to cart. VERIFY against the first 20 real expedited-upgrade orders (the Monday MCF report lists their speed). */
(function (g) {
  'use strict';
  var HOLIDAYS = {
    '2026-01-01': "New Year's Day", '2026-01-19': 'Martin Luther King Jr. Day', '2026-02-16': "Presidents' Day",
    '2026-05-25': 'Memorial Day', '2026-06-19': 'Juneteenth', '2026-07-03': 'Independence Day (observed)',
    '2026-09-07': 'Labor Day', '2026-10-12': 'Columbus Day', '2026-11-11': 'Veterans Day',
    '2026-11-26': 'Thanksgiving Day', '2026-12-25': 'Christmas Day',
    '2027-01-01': "New Year's Day", '2027-01-18': 'Martin Luther King Jr. Day', '2027-02-15': "Presidents' Day",
    '2027-05-31': 'Memorial Day', '2027-06-18': 'Juneteenth (observed)', '2027-07-05': 'Independence Day (observed)',
    '2027-09-06': 'Labor Day', '2027-10-11': 'Columbus Day', '2027-11-11': 'Veterans Day',
    '2027-11-25': 'Thanksgiving Day', '2027-12-24': 'Christmas Day (observed)', '2027-12-31': "New Year's Day 2028 (observed)"
  };
  var FIRST = 2026, LAST = 2027, ARRIVE_EARLY = 3, ARRIVE_LATE = 7, FAST_EARLY = 2, FAST_LATE = 3, FAST_CUTOFF = 14;
  var GENERIC = 'Ships in 1–3 business days';
  var DY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }
  function wday(y, m, d) { return new Date(Date.UTC(y, m - 1, d)).getUTCDay(); }
  function isBusinessDay(y, m, d) {
    var wd = wday(y, m, d);
    return wd >= 1 && wd <= 5 && !HOLIDAYS[key(y, m, d)];
  }
  function addDays(y, m, d, n) {
    var t = new Date(Date.UTC(y, m - 1, d + n));
    return [t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate()];
  }
  function etParts(now) {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false }).formatToParts(now);
    } catch (e) { return null; }
    var p = {};
    for (var k = 0; k < parts.length; k++) { p[parts[k].type] = parts[k].value; }
    var h = parseInt(p.hour, 10);
    var r = { y: +p.year, m: +p.month, d: +p.day, h: isNaN(h) ? 24 : h % 24 };
    return (isNaN(r.y) || isNaN(r.m) || isNaN(r.d)) ? null : r;
  }
  /* The nth business day strictly after y-m-d, as [y, m, d], or null when it falls outside the calendar. */
  function addBusinessDays(y, m, d, n) {
    var c = [y, m, d], k = 0;
    for (var i = 1; i <= 40 && k < n; i++) {
      c = addDays(y, m, d, i);
      if (c[0] > LAST) { return null; }
      if (isBusinessDay(c[0], c[1], c[2])) { k++; }
    }
    return k === n ? c : null;
  }
  /* The first business day strictly after today (America/New_York) for an order placed at `now`, as {y, m, d, today, days}
     (days = calendar days from today; today is always false, there is no same-day dispatch), or null when the calendar can't
     prove it (outside FIRST..LAST, or no Intl time zone support). */
  function shipDate(now) {
    var t = etParts(now);
    if (!t || t.y < FIRST || t.y > LAST) { return null; }
    var n = addBusinessDays(t.y, t.m, t.d, 1);
    if (!n) { return null; }
    return { y: n[0], m: n[1], d: n[2], today: false, days: Math.round((Date.UTC(n[0], n[1] - 1, n[2]) - Date.UTC(t.y, t.m - 1, t.d)) / 86400000) };
  }
  function text() { return GENERIC; }
  function day(c) { return DY[wday(c[0], c[1], c[2])] + ', ' + MO[c[1] - 1] + ' ' + c[2]; }
  /* Delivery estimate for an order placed at `now`: {lead, range, tiny, text, ship, early, late, today, fast, fastDay, fastTiny} or null
     (same limits as shipDate). early = the 3rd business day after the order date, late = the 7th, both on the holiday calendar.
     fast = the Expedited arrival (2nd business day before 2 PM ET, else 3rd), or null past the calendar; fastDay/fastTiny are then ''. */
  function eta(now) {
    var t = etParts(now || new Date());
    if (!t || t.y < FIRST || t.y > LAST) { return null; }
    var s = addBusinessDays(t.y, t.m, t.d, 1), e = addBusinessDays(t.y, t.m, t.d, ARRIVE_EARLY), l = addBusinessDays(t.y, t.m, t.d, ARRIVE_LATE);
    if (!s || !e || !l) { return null; }
    var f = addBusinessDays(t.y, t.m, t.d, t.h < FAST_CUTOFF ? FAST_EARLY : FAST_LATE);
    var lead = GENERIC;
    var range = day(e) + ' – ' + day(l);
    var tiny = e[1] === l[1] ? MO[e[1] - 1] + ' ' + e[2] + '–' + l[2] : MO[e[1] - 1] + ' ' + e[2] + ' – ' + MO[l[1] - 1] + ' ' + l[2];
    return { lead: lead, range: range, tiny: tiny, text: lead + ' · arrives ' + range, ship: s, early: e, late: l, today: false,
      fast: f, fastDay: f ? day(f) : '', fastTiny: f ? MO[f[1] - 1] + ' ' + f[2] : '' };
  }
  var MODES = {
    full: function (x) { return x.text; },
    range: function (x) { return 'Arrives ' + x.range; },
    lead: function (x) { return x.lead + ' · free standard shipping'; },
    tiny: function (x) { return 'Arrives ' + x.tiny; },
    sticky: function (x) { return 'Arrives ' + x.tiny + ' · '; },
    bar: function (x) { return 'arrives ' + x.tiny; },
    rangeonly: function (x) { return x.range; },
    fastday: function (x) { return x.fast ? x.fastDay : 'in 2 business days'; },
    fastrow: function (x) { return x.fast ? 'Get it ' + x.fastDay + ' with Expedited' : 'Expedited delivery in 2 business days'; }
  };
  function paint(root) {
    if (typeof document === 'undefined') { return; }
    var x = eta(new Date());
    if (!x) { return; }
    var els = (root || document).querySelectorAll('[data-tc-eta]');
    for (var i = 0; i < els.length; i++) {
      var f = MODES[els[i].getAttribute('data-tc-eta')] || MODES.full, t = f(x);
      if (els[i].textContent !== t) { els[i].textContent = t; }
    }
  }
  var api = { text: text, shipDate: shipDate, eta: eta, paint: paint, isBusinessDay: isBusinessDay, holidays: HOLIDAYS, generic: GENERIC };
  g.tcDispatch = api;
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof document !== 'undefined' && document.querySelectorAll) {
    var run = function () { paint(); };
    run();
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
    setInterval(run, 30000);
    document.addEventListener('visibilitychange', run);
    g.addEventListener && g.addEventListener('pageshow', run);
    var watch = function () {
      var b = document.querySelector('[data-tc-cd-body]');
      if (b && g.MutationObserver) { new MutationObserver(function () { paint(b); }).observe(b, { childList: true, subtree: true }); }
    };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watch); } else { watch(); }
  }
})(typeof window !== 'undefined' ? window : this);
